import React from 'react';
import EmailPopup from '../EmailPopup';
import { EmailPopupCustomization } from 'src/hooks/usePopupVisibility';
import FormContent from 'molecules/EmailPopup/FormContent/FormContent';
import { useStaticQuery, graphql } from 'gatsby';
import { IStaticContentfulImages } from 'src/types/contentful';
import ThankYouMessage from './ThankYouMessage';
import FailureMessage from '../FailureMessage';

interface StandardEmailPopupProps {
  customization: EmailPopupCustomization;
}

const StandardEmailPopup = ({ customization }: StandardEmailPopupProps): JSX.Element => {
  const { image } = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      image: contentfulAsset(contentful_id: { eq: "1rjl43UkswJENXz5WM6iWe" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1600)
      }
    }
  `);

  const renderContent = (blocked: boolean, customization?: EmailPopupCustomization) => (
    <FormContent
      formId='standardEmailPopup'
      disabled={blocked}
      headingText={customization?.title}
      supportingText={customization?.description}
    />
  );

  return (
    <EmailPopup
      customization={customization}
      baseStorageKey='standardEmailPopup'
      formId='79e916cb-d4f8-4ea5-990c-ee51c8259e7b'
      formWrapperId='standardEmailPopup'
      formContent={renderContent}
      image={{
        image: image.gatsbyImageData,
        alt: 'Email popup image',
      }}
      successContent={() => <ThankYouMessage />}
      failureContent={(handleClose) => <FailureMessage onButtonClick={handleClose} />}
    />
  );
};

export default StandardEmailPopup;
